module.exports = __webpack_public_path__ + "static/media/timelapse_9.60f844ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_9.jpg
// module id = 969
// module chunks = 0